import {
    rosterChecklistsByGroup,
    rosterChecklistUsersByUser
} from './queries'
import { createCompanyNotification } from '@/graphql/mutations'
import store from '@/store'
import { mixinMethods } from "@/main";

const itemById = function(list, id, keyOrCallback) {
    if(!list?.length || !id){
        return undefined
    }
    const item = list.find(cf => cf.id === id) || {}
    switch(typeof keyOrCallback){
        case 'string':
            return item[keyOrCallback]
        case 'function':
            return keyOrCallback(item)
        default:
            return item
    }
}

const getRosterChecklists = async function(){
    const input = {
        group: store.state.userInfo.tenant.group
    }
    const response = await mixinMethods.api(rosterChecklistsByGroup, input)
    return response.data?.rosterChecklistsByGroup?.items || []
}

const findRosterChecklistsByUserId = async function(userId){
    const input = {
        userId,
        group: store.state.userInfo.tenant.group
    }
    const response = await mixinMethods.api(rosterChecklistUsersByUser, input)
    return response.data.rosterChecklistUsersByUser
}

const sendCompanyNotification = async(message)=>{
    let createNotificationInput = {
        group: store.state.userInfo.tenant.group,
        message:  JSON.stringify(message),
        streamTable: 'RosterChecklist',
        affectedTable: 'RosterChecklist',  
        expirationTTL: Math.floor((new Date().getTime() + 1 * 60 * 60 * 1000) / 1000)
    }
    try {
        let result = await mixinMethods.api(createCompanyNotification, {input: createNotificationInput})
        console.log("Success: ", result);
        return result
    } catch (e) {
        console.log("Error: ", e)
    }

}

const conditionalPredicate = (searchConditions, ...args) =>{
    const searchMode = typeof searchConditions
    if(searchMode === 'function'){
        return searchConditions(...args)
    }
    return searchConditions
}

const copyNumber = (value) => {
    const found = /\(Copy(\s(?<count>(\d+)))?\)$/g.exec(value)
    if(found){
        const { count } = found.groups || {}
        return count ? parseInt(count) : 1
    }else{
        return 0
    }
}

const copyRosterChecklistName = (tableData, name, searchConditions, callback) =>{
    const exists = tableData.find(rcl => rcl.name.toUpperCase() === name?.toUpperCase() && conditionalPredicate(searchConditions, rcl))
    if(exists){
        let lastCopies = tableData.filter(rcl => {
            return conditionalPredicate(searchConditions, rcl) &&
                rcl.name.toUpperCase().includes(name?.toUpperCase()) &&
                /\(Copy(\s\d+)?\)$/g.exec(rcl.name)
        })

        let currentCopyNumber

        if(lastCopies.length){

            const lastCopy = lastCopies.reduce((major, copy)=>{
                const count = copy.name === name ? 0 : copyNumber(copy.name)
                if(count > major)
                    return count
                return major
            }, 0)

            currentCopyNumber = lastCopy + 1
        }

        callback?.(name, currentCopyNumber)
        return currentCopyNumber > 1 ? `${name} (Copy ${currentCopyNumber})` : `${name} (Copy)`

    }
    return null
}

export default {
    methods: {
        itemById,
        getRosterChecklists,
        findRosterChecklistsByUserId,
        sendCompanyNotification,
        copyRosterChecklistName
    }
}